import type { TraditionalDoc } from "./doc";

export type TraditionalAction =
  | { type: "SET_TITULO"; titulo: string }
  | { type: "SET_CHAVE"; key: string; chave: string };

// Puro e imutável: sempre devolve um doc novo.
export function traditionalReducer(
  doc: TraditionalDoc,
  a: TraditionalAction,
): TraditionalDoc {
  switch (a.type) {
    case "SET_TITULO":
      return { ...doc, titulo: a.titulo };
    case "SET_CHAVE":
      return {
        ...doc,
        palavras: doc.palavras.map((w) =>
          w.key === a.key ? { ...w, chave: a.chave } : w,
        ),
      };
    default:
      return doc;
  }
}
